module.exports = __webpack_public_path__ + "img/produman.afc171db.jpg";